import request from '@/utils/request'

// 查询多级联动字典列表
export function listMullevel(query) {
  return request({
    url: '/web/system/mullevel/webList',
    method: 'get',
    params: query
  })
}

//传入大类的名称，获取业务类型小类
export function getListByDictName(query) {
  return request({
    url: '/web/system/mullevel/getListByDictName',
    method: 'get',
    params: query
  })
}